import React from "react";

function Buttons(props) {
  return (
    <button
      className={`button ${props.className ?? ""}`}
      type={props.type}
      disabled={props.disabled}
    >
      {props.content}
    </button>
  );
}

export default Buttons;
